import React from 'react'
import LeadershipLinks from '../LeadershipLinks'
import '../../../App.css'
import ImageComponent from '../../ImageComponent'

function DarrellHayslip() {
    return (
      <div className='bio-pages main-grid-container'>
      <div className='main-grid-item'>
    <LeadershipLinks/>
    </div>
          <div className='main narrow-grid'>
            <div className='bio-img-wrapper'>
              <ImageComponent src={require('../../../img/darrell_hayslip_bio_portrait_1000px.jpg')} />
          {/* <img src={require('../../../img/darrell_hayslip_bio_portrait_1000px.jpg')} alt='larry loden portrait' /> */}
          </div>
            <h1 className='bio-header'>Darrell Hayslip</h1>
            {/* <h2 className='bio-subheader'>Marriage & Family Counseling</h2> */}
            <p> Darrell Hayslip serves as Marriage & Family Counseling pastoral staff here at Grace Community Fellowship.<br/><br/>
                Darrell received a BS degree in Engineering from UT Austin and spent over 25 years in the independent power industry as executive leadership for various companies & industry boards. After coming to the Lord in 2008 and learning of God’s incredible design for marriage, Darrell has devoted himself to helping others understand the beauty of a God-glorifying marriage & family, and the biblical foundation upon which people can experience it as God intended. <br/><br/>
                In 2017, he left the power industry to devote himself full-time to marriage, discipleship, and biblical counseling. He is a trained Biblical Counselor through the Austin Stone Counseling Center as well as a certified member of Association of Certified Biblical Counselors (ACBC).
            </p>
          </div>
          
        </div>
      )
    }

export default DarrellHayslip
